import { useEffect } from "react";

import { executeJs } from "../lib/execute-js";

type ScriptInjectionProps = {
  script: string;
  target: "head" | "body";
};

export const ScriptInjection: React.FC<ScriptInjectionProps> = ({
  script,
  target,
}) => {
  useEffect(() => {
    if (!script) return;
    executeJs(script, target);
  }, [script, target]);

  return null;
};
